module.exports = __webpack_public_path__ + "static/img/standardPic1.f44b318c.png";